import React from "react";

const RaffleWork = () => {
    return (
        <div className="erg-how text-center p-5 mb-5" style={{padding: "4rem !important"}}>
            <p>
                Ergo Raffle is a crowdfunding service that aims to enable anyone to raise enough money needed for a
                project. The project can be a direct donation to a charity, an academic or business plan, or anything
                else the creator can convince people to part with their hard-earned ERG for. As an added bonus, after
                finishing the Raffle, a lottery takes place at the end of the Raffle, and one lucky participant wins a
                set percent of the Raffle as the 'Raffle reward'.
            </p>
        </div>
    )
}

export default RaffleWork;
